import isWrappedBy from './is-wrapped-by';
import isWrapperRegistered from './is-wrapper-registered';

export default {
  isWrappedBy,
  isWrapperRegistered,
};
